export default __webpack_public_path__ + "static/media/gif_ani.c3b387ed.gif";